"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataInterfaces_1 = require("../Types/DataInterfaces");
//----------------------------------------Matrix reduction start
function reduceData(datapoints, TTS, balance, annualWithdrawal, fumObject, optimizationObject) {
    var reducedValues = {};
    datapoints.forEach(function reduce(d) {
        //----Calculate TTS Modification Factor-----
        var TTSMod = 0;
        if (d.isWhatIf) {
            TTSMod = 1;
        }
        //-----------------------------------------
        if (typeof d === 'undefined' || typeof d.timestep === 'undefined') {
            return;
        }
        ;
        var datapoint = Object.assign({}, d);
        //Correct NaN values
        if (!datapoint.value) {
            datapoint.value = 0;
        }
        ;
        var shouldAdd = false;
        switch (datapoint.metric) {
            case "Bequest":
                if (!(datapoint.id in reducedValues) || datapoint.timestep == TTS - TTSMod) {
                    shouldAdd = true;
                }
                break;
            case "Likelihood":
                if (!(datapoint.id in reducedValues) || datapoint.timestep === TTS - TTSMod) {
                    datapoint.value *= 100;
                    shouldAdd = true;
                }
                break;
            case "Shortfall":
                if (!(datapoint.id in reducedValues) || datapoint.timestep === -1) {
                    var value = datapoint.value / annualWithdrawal;
                    var roundedValue = Math.floor(value * 10) / 10;
                    datapoint.value = roundedValue;
                    shouldAdd = true;
                }
                break;
            default:
                break;
        }
        datapoint.value = datapoint.value || 0;
        if (shouldAdd) {
            reducedValues[datapoint.id] = datapoint;
        }
        ;
        //SUPER JANKY MIGHT CHANGE LATER?  One shortfall per column so we're exploitinng this property to create the safe withdrawal data points
        if (datapoint.metric === "Shortfall") {
            //const gfcFactor = datapoint.isWhatIf ? gfc.isGfc : gfc.notGfc;
            var rate = optimizationObject[datapoint.portfolioOrigin][DataInterfaces_1.gfc.notGfc]; //For some reason we do not use the gfc optimization values
            var trueSafeWithdrawal = -1;
            //------------Get the FUM factor------------
            var fumFactor = fumObject[d.portfolioOrigin][DataInterfaces_1.gfc.notGfc];
            //-----------FUM FACTOR FINISHED------------
            trueSafeWithdrawal = datapoint.isWhatIf ? fumFactor * rate * balance : rate * balance; //* fumFactor
            var safeWithdrawalEntry = Object.assign({}, datapoint);
            safeWithdrawalEntry.id = "SafeWithdrawal|" + datapoint.name + datapoint.portfolioOrigin;
            safeWithdrawalEntry.metric = "SafeWithdrawal";
            safeWithdrawalEntry.value = trueSafeWithdrawal;
            reducedValues["SafeWithdrawal|" + datapoint.name + datapoint.isWhatIf + datapoint.portfolioOrigin] = safeWithdrawalEntry;
        }
    });
    var responseTree = treeify(reducedValues);
    return responseTree;
}
exports.reduceData = reduceData;
//----------------------------------------Matrix reduction finish
//----------------------------------------Graph reduction start
function generateGraphPoints(dataArr) {
    var valueTree = {};
    dataArr.forEach(function reduceGraphData(dPoint) {
        var strategy = dPoint.portfolioOrigin;
        var percentile = dPoint.percentile || 0;
        var value = dPoint.value || 0;
        if (strategy in valueTree) {
            if (percentile in valueTree[strategy]) {
                valueTree[strategy][percentile].push(value);
            }
            else {
                valueTree[strategy][percentile] = [value];
            }
        }
        else {
            valueTree[strategy] = {};
            valueTree[strategy][percentile] = [value]; //percentile becomes a string here because javascript makes it so
        }
    });
    var reducedValues = {};
    Object.keys(valueTree).forEach(function iterateStrategies(strategy) {
        reducedValues[strategy] = {};
        Object.keys(valueTree[strategy]).forEach(function iteratePercentiles(percentile) {
            reducedValues[strategy][percentile] = averageArray(valueTree[strategy][percentile]);
        });
    });
    return reducedValues;
}
exports.generateGraphPoints = generateGraphPoints;
//----------------------------------------Graph reduction finish
function averageArray(arr) {
    var sum = arr.reduce(function (total, number) { return total + number; });
    return sum / arr.length;
}
function reduceBackTestData(dataArr) {
    var reducedData = {};
    dataArr.forEach(function (point) {
        var newPoint = { value: point.value, time: point.timestep };
        if (!reducedData[point.portfolioOrigin]) {
            reducedData[point.portfolioOrigin] = { name: point.displayName, data: [] };
        }
        reducedData[point.portfolioOrigin].data.push(newPoint);
    });
    return reducedData;
}
exports.reduceBackTestData = reduceBackTestData;
function treeify(reducedData) {
    var finalTree = {};
    var leaves = Object.values(reducedData);
    leaves.forEach(function (leaf) {
        if (!finalTree.hasOwnProperty(leaf.portfolioOrigin)) { //THERE'S A NOT IN THAT IF STATEMENT
            finalTree[leaf.portfolioOrigin] = {};
        }
        var whatIfProperty = leaf.isWhatIf ? DataInterfaces_1.gfc.isGfc : DataInterfaces_1.gfc.notGfc;
        if (!finalTree[leaf.portfolioOrigin].hasOwnProperty(whatIfProperty)) { //THERE'S A NOT IN THAT IF STATEMENT
            finalTree[leaf.portfolioOrigin][whatIfProperty] = {};
        }
        finalTree[leaf.portfolioOrigin][whatIfProperty][leaf.metric] = leaf;
    });
    return finalTree;
}
//# sourceMappingURL=DataReducer.js.map